//const PATH = 'http://10.0.68.44:8050/datasnap/ExpressoAPI/TServerMethodsDati'
//const PATH = 'http://192.168.2.158:8050/datasnap/ExpressoAPI/TServerMethodsDati'
//const PATH = 'http://172.16.218.131:8050/datasnap/ExpressoAPI/TServerMethodsDati'
//const PATH = 'http://127.0.0.1:8050/datasnap/ExpressoAPI/TServerMethodsDati'
//const PATH = 'http://10.1.0.4:8050/datasnap/ExpressoAPI/TServerMethodsDati'
const PATH = 'http://40.115.101.64:8050/datasnap/ExpressoAPI/TServerMethodsDati'
//const PATH = 'http://192.168.255.166:8050/datasnap/ExpressoAPI/TServerMethodsDati'

async function listaStatistiche() {                
    let response = await fetch(PATH+'/ListaStatistiche', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function elimina(table, campoID, campoDelete, ID) {                
    const response = await fetch(PATH+'/Elimina', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({               
            table: table,
            campoID: campoID,
            campoDelete: campoDelete, 
            ID: ID,
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        let resp = (await response.json()).result;                
        if (resp.length==0)
            throw "No Data"
        else if (resp[0]==null)
            throw "No Data"
        resp = resp[0]        
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function reorder(table, campoID, campoProgressivo, ID, nuovoProgressivo) {            
    const response = await fetch(PATH+'/Reorder', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({               
            table: table,
            campoID: campoID,            
            campoProgressivo: campoProgressivo,            
            ID: ID,
            nuovoProgressivo: nuovoProgressivo,
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        let resp = (await response.json()).result;                
        if (resp.length==0)
            throw "No Data"
        else if (resp[0]==null)
            throw "No Data"
        resp = resp[0]        
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function eseguiStatistica(idStatistica, listaValori) {        
    const response = await fetch(PATH+'/Statistica', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({   
            id: idStatistica, 
            valueList: listaValori,                       
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        let resp = (await response.json()).result;        
        if (resp.length==0)
            throw "No Data"
        else if (resp[0]==null)
            throw "No Data"
        resp = resp[0]
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function listaModuli() {                
    let response = await fetch(PATH+'/ListaModuli', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function listaFlussoModuli() {                
    let response = await fetch(PATH+'/ListaModGeico', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function modificaFlussoModuli(valori) {         
    const response = await fetch(PATH+'/ModGeico', {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                        
        body: JSON.stringify({    
            ...valori,
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function listaArticoli(idFamiglia) {                
    let response = await fetch(PATH+'/ListaArticoli', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName(),
            ART_IDARTFAMIGLIA: idFamiglia
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function nuovoArticolo(idFamiglia, valori) {      
    const response = await fetch(PATH+'/Articolo', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({            
            ART_IDARTFAMIGLIA: idFamiglia,
            ART_CODARTICOLO: valori.ART_CODARTICOLO,
            ART_DESCRIZIONE: valori.ART_DESCRIZIONE,
            ART_DESCAGGIUNTIVA: valori.ART_DESCAGGIUNTIVA,
            ART_INUSO: valori.ART_INUSO,
            ART_SCORTAMINIMA: valori.ART_SCORTAMINIMA?valori.ART_SCORTAMINIMA:0,
            ART_OLDTOTALE: valori.ART_OLDTOTALE?valori.ART_OLDTOTALE:0,
            ART_TOTALE: valori.ART_TOTALE?valori.ART_TOTALE:0,
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {        
        const resp = await response.json();
        return  resp.result[0];
    }
    else
        throw response.statusText;
}

async function modificaArticolo(valori) { 
    
    const response = await fetch(PATH+'/Articolo', {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                        
        body: JSON.stringify({    
            ART_IDARTFAMIGLIA: valori.ART_IDARTFAMIGLIA,
            ART_CODARTICOLO: valori.ART_CODARTICOLO,
            ART_DESCRIZIONE: valori.ART_DESCRIZIONE,
            ART_DESCAGGIUNTIVA: valori.ART_DESCAGGIUNTIVA,
            ART_INUSO: valori.ART_INUSO,
            ART_IDARTICOLO: valori.ART_IDARTICOLO,    
            ART_SCORTAMINIMA: valori.ART_SCORTAMINIMA,
            ART_OLDTOTALE: valori.ART_OLDTOTALE,
            ART_TOTALE: valori.ART_TOTALE,        
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function listaUtenti() {                
    let response = await fetch(PATH+'/ListaUtenti', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName(),            
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function OttieniGGPermanenza() {                
    let response = await fetch(PATH+'/OttieniGGPermanenza', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName(),            
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function AggiornaGGPermanenza(GGPermanenza) {                
    let response = await fetch(PATH+'/RegistraGGPermanenza', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName: getSessionName(),
            AZ_GGPERMANENZA: GGPermanenza
        })
    })     
    if (response.ok) {                
        const lista = (await response.json()).result[0];                
        if (lista.error) {
            throw lista.error;
        }            
        else {                                  
            return lista;
        }    
    }  
}

async function nuovoUtente(valori) {    
    const response = await fetch(PATH+'/Utente', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                        
            UT_ALIAS: valori.UT_ALIAS,
            UT_SMTPEMAIL: valori.UT_SMTPEMAIL,
            UT_FLAGATTIVO: valori.UT_FLAGATTIVO,
            UT_PASSWORD: valori.UT_PASSWORD,   
            UT_IDUTENTERESPONSABILE: valori.UT_IDUTENTERESPONSABILE,         
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {        
        const resp = await response.json();
        return  resp.result[0];
    }
    else
        throw response.statusText;
}

async function modificaUtente(valori) {     
    const response = await fetch(PATH+'/Utente', {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                        
        body: JSON.stringify({            
            UT_ALIAS: valori.UT_ALIAS,
            UT_SMTPEMAIL: valori.UT_SMTPEMAIL,
            UT_FLAGATTIVO: valori.UT_FLAGATTIVO,
            UT_PASSWORD: valori.UT_PASSWORD,
            UT_IDUTENTE: valori.UT_IDUTENTE,
            UT_IDUTENTERESPONSABILE: valori.UT_IDUTENTERESPONSABILE,            
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    } else
        throw response.statusText;
}

async function modificaPwdUtente(pwd) {     
    const response = await fetch(PATH+'/PwdUtente', {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                        
        body: JSON.stringify({              
            UT_PASSWORD: pwd,
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    } else
        throw response.statusText;
}

async function listaStatoMacchina(idTipoRicerca, idAuto) {                
    let response = await fetch(PATH+'/ListaStatoMacchine', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            ART_IDARTICOLO: idAuto,
            IDTIPORIC: idTipoRicerca,
            sessionName: getSessionName()           
        })
    })         
    if (response.ok) {                        
        const res = (await response.json()).result[0];                        
        if (res == null)
            return []
        if (res.error) 
            throw res.error;               
        return res;
    } else
        throw response.statusText;
}

async function nuovoStatoMacchina(valori) {    
    const response = await fetch(PATH+'/StatoMacchine', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                        
            GRAA_IDUTENTE: valori.GRAA_IDUTENTE,
            GRAA_IDARTICOLO: valori.GRAA_IDARTICOLO,
            GRAA_DATAORAINIZIO: valori.GRAA_DATAORAINIZIO,
            GRAA_DATAORAFINE: valori.GRAA_DATAORAFINE,
            GRAA_IDSTATO: valori.GRAA_IDSTATO,            
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {                
        const res = (await response.json()).result[0];                
        if (res.error) 
            throw res.error;               
        return res;
    } else
        throw response.statusText;
}

async function modificaStatoMacchina(valori) {     
    const response = await fetch(PATH+'/StatoMacchine', {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                        
        body: JSON.stringify({    
            GRAA_IDUTENTE: valori.GRAA_IDUTENTE,
            GRAA_IDARTICOLO: valori.GRAA_IDARTICOLO,
            GRAA_DATAORAINIZIO: valori.GRAA_DATAORAINIZIO,
            GRAA_DATAORAFINE: valori.GRAA_DATAORAFINE,
            GRAA_IDSTATO: valori.GRAA_IDSTATO,    
            GRAA_IDRICHIESTAAUTO: valori.GRAA_IDRICHIESTAAUTO,        
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {                
        const res = (await response.json()).result[0];                
        if (res.error) 
            throw res.error;               
        return res;
    } else
        throw response.statusText;
}

async function nuovoRapporto(idModuloTestata) {    
    const response = await fetch(PATH+'/Rapporto', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            moduleId: idModuloTestata,
            sessionName: getSessionName()
        })
    })     
    if (response.ok) {        
        const resp = await response.json();
        return  resp.result[0];
    }
    else
        throw response.statusText;
}

async function ottieniRapporto(idModuloTestata, vis = 0) {
    if (!vis)
        vis=0
    const response = await fetch(PATH+'/Rapporto/'+idModuloTestata, {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({            
            sessionName: getSessionName(),
            flagVis: vis
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];        
        if (resp.error)
            throw resp.error
        else
            return resp;
    }
    else
        throw response.statusText;
}

async function eseguiAzione(idRappDett, idAzione, listaValori, artSelez) {    
    const response = await fetch(PATH+'/AzioneRapporto/'+idRappDett+'/'+idAzione, {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({    
            valueList: listaValori,           
            artSelez: artSelez,
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function annullaRapporto(idRapportoTestata) {    
    const response = await fetch(PATH+'/AnnullaRapporto/'+idRapportoTestata, {        
        method: 'POST',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                
            sessionName: getSessionName()
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];                
        if (resp.error) {
            throw resp.error
        } else {
            return resp            
        }        
    }
    else
        throw response.statusText;
}

async function listaRapporti(idModuloTestata,reqType) {
    if (!idModuloTestata)
        return null    
    let tipoRichiesta = null;
    switch (reqType) {
        case "1":
            tipoRichiesta="tutti"            
            break;    
        case "2":
            tipoRichiesta="da_terminare"
            break;    
        case "3":
            tipoRichiesta="tutti_per_utente"
            break;    
        case "4":
            tipoRichiesta="da_terminare_per_utente"
            break;  
        default:   
            tipoRichiesta="null"
            break;                 
    }    
    const response = await fetch(PATH+'/listaRapporti', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        
        body: JSON.stringify({           
            moduleId: idModuloTestata,    
            reqType: tipoRichiesta,
            sessionName: getSessionName()       
        })
    });     
    if (response.ok) {        
        const resp = (await response.json()).result[0];        
        if (resp) {
            if (resp.error) {
                throw resp.error;
            }            
            else {                                  
                return resp;
            }      
        } else {
            return null
        }    

    }
    else
        throw response.statusText;
}


function getSessionName() {
    return JSON.parse(localStorage.getItem('sessionName')).sessionName;
}

async function logIn(crd) {                
    let response = await fetch(PATH+'/Session/', {        
        method: 'PUT',         
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            email: crd.user,
            password: crd.password
        })
    })     
    if (response.ok) {                
        const user = (await response.json()).result[0];                
        if (user.error) {
            throw user.error;
        }            
        else {                      
            localStorage.setItem('sessionName','{"sessionName": "'+user.sessionName+'"}')        
            return user;
        }    
    }  
}

async function getUserInfo() {  
    const response = await fetch(PATH+'/getSession/'+getSessionName());                
    if (response.ok) {
        const user = (await response.json()).result[0];                
        if (user.error) {            
            throw user.error;
        }            
        else {            
            return user;
        }    
    }
}

async function logOut() {
    await fetch(PATH+'/logout', {
        method: 'PUT',
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({
            sessionName : getSessionName()
        })
    })
}

async function ottieniDestinatari(idRappDett, idAzione) {
    const response = await fetch(PATH+'/destinatari/'+idRappDett+'/'+idAzione, {
        method: 'POST',
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                       
            sessionName: getSessionName()       
        })
    })
    if (response.ok) {
        const user = (await response.json()).result[0];                
        if (user.error) {            
            throw user.error;
        }            
        else {            
            return user;
        }    
    }
}

async function inviaADestinatari(idRappDett, idAzione, destinatari) {
    const response = await fetch(PATH+'/destinatari/'+idRappDett+'/'+idAzione, {
        method: 'PUT',
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                       
            destinatari : destinatari,
            sessionName: getSessionName()       
        })
    })
    if (response.ok) {
        const user = (await response.json()).result[0];                
        if (user.error) {            
            throw user.error;
        } else {            
            return user;
        }    
    }    
}

async function statoAuto() {
    const response = await fetch(PATH+'/StatoAuto/', {
        method: 'PUT',
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                                   
            sessionName: getSessionName()       
        })
    })
    if (response.ok) {
        const user = (await response.json()).result[0];                        
        if (!user) 
            return null
        if (user.error) {            
            throw user.error;
        } else {                        
            return user;
        }    
            
    }
}

async function statoRichiesteUtente(familyId,userRequester) {
    const response = await fetch(PATH+'/StatoRichiesteUtente/', {
        method: 'PUT',
        headers: {                        
            'Content-Type': 'application/json'            
        },                
        body: JSON.stringify({                                   
            sessionName: getSessionName(),
            familyId: familyId,
            userId: userRequester        
        })
    })    
    if (response.ok) {
        const user = (await response.json()).result[0];                        
        if (!user) 
            return null;

        if (user.error) {            
            throw user.error;
        } else {                        
        return user;
          
        }    
    }
}

const API = {
    listaModuli,
    nuovoRapporto, ottieniRapporto, listaRapporti, eseguiAzione,
    ottieniDestinatari, inviaADestinatari, annullaRapporto,
    statoAuto, statoRichiesteUtente,
    listaArticoli, nuovoArticolo, modificaArticolo,
    listaUtenti, nuovoUtente, modificaUtente, modificaPwdUtente,
    listaStatoMacchina, nuovoStatoMacchina, modificaStatoMacchina,
    listaStatistiche, eseguiStatistica,
    listaFlussoModuli, modificaFlussoModuli,
    logIn, getUserInfo, logOut,  
    elimina, reorder,
    AggiornaGGPermanenza, OttieniGGPermanenza 
};

export default API;